import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap'

export default function TermsPage(props) {

    return (
        <div>
            <div className="border-bottom pb-3 mb-3 mt-3">
                <h5>Terms & Condition / 抽籤條款及細則</h5>
                <p>
                    Please agree to the terms & conditions<br />
                    請同意條款及細則*
                </p>
				
                <h5>Terms & Condition</h5>
                <ol>
                    <li>
                        This event is organized by Sportshouse Limited (“Sportshouse”/ “We”). This event opens only to the participants who reach the age of thirteen (13) or older at the time of entry, with a valid identity proof document (“HKID/Passport”) and Hong Kong registered mobile telephone number. 
                    </li>
                    <li>
                        Each person can submit one registration only. Applicant will be disqualified automatically if more than one registration is submitted. To ensure fairness, employees of Sportshouse shall not participate in the event.
                    </li>
                    <li>
                        Please ensure the information provided is correct and the relevant information cannot be modified once submitted. Sportshouse shall not be held liable for the problem that we could not contact or verify the identity of the participants who fail to provide complete and or correct personal particulars or contact(s).
                    </li>
                    <li>
                        Regarding registration period of the event, please refer to the information being provided in this event website.
                    </li>
                    <li>
                        The successful applicant will be notified via email with purchase details while unsuccessful applicant will regrettably not be notified individually.
                    </li>
                    <li>
                        Successful applicant must follow the purchase details in the email notification, and present original HKID/Passport in person, printout of email confirmation to purchase the assigned style and size at the assigned store during business hours (style and size of the product is being arranged according to what you have filled in the registration form, no changes can be made once registered) .
                    </li>
                    <li>
                        If the successful applicant fail to purchase the product at the time and location specified or fail to present the identification document to match with the registration, the purchasing right will be taken as waived by the applicant and be forfeited accordingly.
                    </li>
                    <li>
                        Successful applicant must provide with proof of original HKID/Passport in person with a first and last name that must be exactly the same with the first and last name contained in the registration form (including the numbers of characters, spelling, sequence, space and the first five characters/digits of the HKID/Passport number), any mismatch information between your application and your HKID/Passport will result a loss of eligibility to purchase the product.
                    </li>
                    <li>
                        Successful applicant should check the product in the store and confirmed it is flawless in appearance before completing the payment. Once payment is completed, no exchange, return or refund shall be allowed unless the product itself has a quality issue.
                    </li>
                    <li>
                        Our shop staff has the right to require successful applicant to take photo when picking up the product as internal record.
                    </li>
                    {
                        props.socialMedia && <li>
                            This event is only limited to applicants that have subscribed and followed below social media account(s)
                            <br />
                            <ul>
                                {props.socialMediaAcName && <li><a href={props.socialMediaPath} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName}</a></li>}
                                {props.socialMediaAcName2 && <li><a href={props.socialMediaPath2} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName2}</a></li>}
                                {props.socialMediaAcName3 && <li><a href={props.socialMediaPath3} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName3}</a></li>}
                                {props.socialMediaAcName4 && <li><a href={props.socialMediaPath4} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName4}</a></li>}
                                {props.socialMediaAcName5 && <li><a href={props.socialMediaPath5} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName5}</a></li>}
                                {props.socialMediaAcName6 && <li><a href={props.socialMediaPath6} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName6}</a></li>}
                                {props.socialMediaAcName7 && <li><a href={props.socialMediaPath7} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName7}</a></li>}
                                {props.socialMediaAcName8 && <li><a href={props.socialMediaPath8} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName8}</a></li>}

                            </ul>
                        </li>
                    }
                    {
                        props.socialMedia && <li>
                            During the pick up process, the successful applicant would be requested by our shop staff to demonstrate the social media account used to register for the event and is following our social media account(s).
                        </li>
                    }
                    <li>
                        This event is governed by its terms and conditions. Before you participate this event, please click the following hyperlink for the privacy policy under this event and for particulars of how we deal with your personal data, please click <a href="https://www.sportshouse.com/Sportshouse_privacy_disclaimer.pdf" rel="noopener noreferrer"  target="_blank;">this hyperlink</a> .
                        Once you make the registration and participate in this event by clicking the Box □ “Agree”, it is constituted that you agree to the terms and conditions of this event and you acknowledge and agree to our privacy policy and our arrangement of handling your personal data, as stipulated in the said hyperlinks.
                    </li>
                    <li>
                        Sportshouse reserves all rights in exercising the final decision in case of disputes.
                    </li>
                </ol>
				
                <h5>條款及細則</h5>
                <ol>
                    <li>
                        本活動由運動家有限公司 ("運動家"/ “本公司”) 舉辦。 本活動只限年滿十三歲﹝以參加當刻的年齡為準﹞、並持有有效之身份證明文件(香港身份證/護照)、以及有效香港手提電話號碼之人士參加。
					</li>
                    <li>
                        每人只限登記一次，重覆參加者將會自動取消資格。運動家員工不得參與此活動，以示公允。
					</li>
                    <li>
                        參加者所填寫的資料必須正確無誤，有關資料一經遞交便不能作任何修改。本公司不會就參加者所提供的資料錯誤而引致無法通知參加者或核對參加者身份而負上任何責任。
					</li>
                    <li>
                        有關本活動登記及完結時間，請參閱本活動網頁的資料。
                    </li>
                    <li>
                        本活動的得獎者將收到個別電郵通知購買詳情。未被抽中的參加者將不獲另行通知。
                    </li>
                    <li>
                        中獎者須根據電郵通知，親身帶同香港身份證或護照及確認電郵列印本於指定時間到指定店舖，在該店舖的營業時間內購買指定產品 (有關指定產品，尺碼是根據登記時之要求安排，不能作出更改或更換其他產品) 。
                    </li>
                    <li>
                        中獎者如未能於指定時間購買指定產品則當作自動放棄購買權，本公司不接受代購或保留產品。
                    </li>
                    <li>
                        中獎者必須親身出示與登記資料相符的身份證明文件正本 (當中所記錄的姓氏和名字須與中獎的登記條目中的姓名及身份完全相同，包括姓名字數、拼法、排列次序、間隔、香港身份證或護照號碼首5位字元包括英文字母等資料完全一樣) , 如有任何差異，均會導致損失購買資格。
                    </li>
                    <li>
                        中獎者請即場檢查指定產品，一經確認購買，除產品品質問題以外，中獎者將不能更換其他商品，退貨或退款。
                    </li>
                    <li>
                        本公司店員會有權要求中獎者取貨時拍照作內部紀錄。
                    </li>
                    {
                        props.socialMedia && <li>
                            是次產品活動只限已訂閱以下社交平台的帳戶參加。
                            <br />
                            <ul>
                                {props.socialMediaAcName && <li><a href={props.socialMediaPath} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName}</a></li>}
                                {props.socialMediaAcName2 && <li><a href={props.socialMediaPath2} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName2}</a></li>}
                                {props.socialMediaAcName3 && <li><a href={props.socialMediaPath3} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName3}</a></li>}
                                {props.socialMediaAcName4 && <li><a href={props.socialMediaPath4} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName4}</a></li>}
                                {props.socialMediaAcName5 && <li><a href={props.socialMediaPath5} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName5}</a></li>}
                                {props.socialMediaAcName6 && <li><a href={props.socialMediaPath6} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName6}</a></li>}
                                {props.socialMediaAcName7 && <li><a href={props.socialMediaPath7} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName7}</a></li>}
                                {props.socialMediaAcName8 && <li><a href={props.socialMediaPath8} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName8}</a></li>}

                            </ul>
                        </li>
                    }
                    {
                        props.socialMedia && <li>
                            取貨過程中，店員會要求中獎者出示與登記資料相符的社交平台帳號及確認已追蹤本公司帳號。
                        </li>
                    }
                    <li>
                        本活動受有關條款及細則規範，而有關本活動的個人資料及免責聲明則詳見於下面<a href="https://www.sportshouse.com/Sportshouse_privacy_disclaimer.pdf" target="_blank;" rel="noopener noreferrer" >連結</a>。
                         請 閣下參與前, 務必細讀有關條款及細則與及有關個人資料及免責聲明的內容，一經參與並按同意，則表達你已同意有關條款及細則與及個人資料的安排及處理。
                    </li>
                    <li>
                        如有任何爭議，運動家保留最終決定權。
                    </li>
                </ol>
            </div>

            <FormGroup check>
                <Label check>
                    <Input
                        type="checkbox"
                        checked={props.value}
                        onChange={props.onChange}
                    />
                    {' '}
                  Agree / 同意
                </Label>
            </FormGroup>
        </div>
    );
}
